import PropTypes from "prop-types";

const STAGES = [
  {
    icon: "/b2b/b2b1.svg",
    title: "Understand the team",
    bullets: [
      "Map current workflows and tools",
      "Identify key friction points",
      "Align on real team needs before building",
    ],
  },
  {
    icon: "/b2b/b2b2.svg",
    title: "Align the Format Mix",
    bullets: [
      "Tailor learning to team size and goals",
      "Blend live sessions, recordings, content",
      "Create a format that actually fits daily work",
    ],
  },
  {
    icon: "/b2b/b2b3.svg",
    title: "Deliver Live & Async",
    bullets: [
      "Run structured, hands-on live sessions",
      "Record and organize everything for reuse",
      "Enable learning on individual schedules",
    ],
  },
  {
    icon: "/b2b/b2b4.svg",
    title: "Reinforce Daily",
    bullets: [
      "Share bite-sized updates via WhatsApp",
      "Keep concepts active through weekly nudges",
      "Build consistency without extra effort",
    ],
  },
  {
    icon: "/b2b/b2b5.svg",
    title: "Support Continued Adoption",
    bullets: [
      "Continuously update learning content",
      "Layer ongoing support over time",
      "Prevent drop-off after initial sessions",
    ],
  },
];

const StageCard = ({ stage, index }) => (
  <div
    className="relative shrink-0 overflow-hidden rounded-[2px] border border-[#FFFFFF33] bg-cover bg-center w-full md:w-[335px] md:h-[320px] p-6 "
    style={{
      borderColor: "rgba(255,255,255,0.20)",
      backgroundImage: "url(/b2b/b2bbg.webp)",
    }}
  >
    <div className="flex h-full flex-col">
      <img
        src={stage.icon}
        alt=""
        className="h-8 w-8"
        loading="lazy"
        decoding="async"
      />
      <p className="mt-6 text-[10px] font-medium uppercase tracking-[1.75px] text-white/70">
        Stage {index + 1}
      </p>
      <h3 className="mt-2 text-[18px] md:text-[20px] font-medium leading-snug text-white">
        {stage.title}
      </h3>
      <ul className="mt-4 flex flex-col gap-2">
        {stage.bullets.map((b, i) => (
          <li key={i} className="flex items-start gap-2">
            <img
              src="/b2b/b2btick.svg"
              alt=""
              className="mt-0.5 h-4 w-4 shrink-0"
              loading="lazy"
              decoding="async"
            />
            <span className="text-[13px] md:text-[14px] leading-snug text-white/70">
              {b}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </div>
);

StageCard.propTypes = {
  stage: PropTypes.shape({
    icon: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    bullets: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  index: PropTypes.number.isRequired,
};

const BusinessStages = () => {
  return (
    <section
      id="business-stages"
      className="relative w-full bg-[#08090A] font-fira-sans"
      style={{
        borderTop: "1px solid rgba(255,255,255,0.15)",
        borderBottom: "1px solid rgba(255,255,255,0.15)",
      }}
    >
      {/* Decorative rails — full-height vertical lines that the cards scroll over */}
      <div
        aria-hidden="true"
        className="hidden md:block pointer-events-none absolute inset-y-0 left-[153px] w-px"
        style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
      />
      <div
        aria-hidden="true"
        className="hidden md:block pointer-events-none absolute inset-y-0 right-[153px] w-px"
        style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
      />
      {/* Mobile rails */}
      <div
        aria-hidden="true"
        className="md:hidden pointer-events-none absolute inset-y-0 left-[5%] w-px"
        style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
      />
      <div
        aria-hidden="true"
        className="md:hidden pointer-events-none absolute inset-y-0 right-[5%] w-px"
        style={{ backgroundColor: "rgba(255,255,255,0.15)" }}
      />

      <div className="relative">
        {/* Heading stays inside the rails */}
        <div className="w-[90%] md:w-auto mx-auto md:mx-[153px] px-4 md:pl-[60px] md:pr-[60px] py-16">
          <p className="text-white/70 uppercase tracking-[1.75px] text-sm">
            How engagements work
          </p>
          <h2 className="mt-3 md:mt-4 text-white text-[30px] md:text-[42px] font-medium leading-tight">
            A Five-stage engagement model
          </h2>
          <p className="mt-3 md:mt-4 text-sm md:text-base text-white/60 leading-relaxed">
            Most engagements run across 8 to 12 weeks with ongoing support built in.
          </p>
        </div>

        {/* Mobile: stacked cards — kept inside the rails */}
        <div className="md:hidden w-[90%] mx-auto pb-12">
          <div className="px-4 flex flex-col gap-4">
            {STAGES.map((stage, i) => (
              <StageCard key={stage.title} stage={stage} index={i} />
            ))}
          </div>
        </div>

        {/* Desktop: full-width horizontal scroll — cards overflow over the rails */}
        <div className="relative hidden md:block pb-12">
          <div
            className="overflow-x-auto"
            style={{ scrollbarWidth: "thin" }}
          >
            <div className="flex gap-5 pl-[213px] pr-[213px]">
              {STAGES.map((stage, i) => (
                <StageCard key={stage.title} stage={stage} index={i} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BusinessStages;
